<template lang="pug">
pr-wrapper#error.align-items-start.justify-content-between.h-100.flex-column.p-5(fs, zi=999, bg)
  img(src="@/assets/images/software.png", style="width: 150px; opacity: 0.75")
  .error-container.d-flex.align-items-center
    img.error-image.ml-5(src="@/assets/images/error.png", style="width: 150px")
    .error-content.ml-5
      .error-title.h1 Something Went Wrong
      .error-description.h5.font-weight-light {{ error.message || error.statusText || error }}
  .error-footer
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "error",
  computed: {
    ...mapState(["error"])
  },
  mounted() {
    _$.sleep(1000).then(() => _$.nav.disable())
  },
  destroyed() {
    _$.nav.enable()
  }
}
</script>

<style lang="scss" scoped>
#error {
  display: flex;
}
</style>
